// import { useAppSelector } from "@app/hooks";
import { APIPostFolder, BackendFolder, FolderApiResponse } from "@dataRoomSetup/models";
// import { FetchDocumentsRequestBody } from "@documents/models/api.models";
// import { impersonationStateSelector } from "@impersonateUser/store/selectors";
import { AppThunkAPI } from "@shared/models/redux";
import { RequestConfig } from "@shared/models/request";
// import { RequestConfig } from "@shared/models/request";
// import { userSliceSelector } from "@user/store/selectors";

type CallFoldersAPI = (
  id: number,
  entitledUserId: string | undefined,
  body?: APIPostFolder[],
  options?: RequestConfig<FolderApiResponse>
) => AppThunkAPI<Promise<BackendFolder[]>>;

export const fetchInitialFolders: CallFoldersAPI =
  (id, entitledUserId, body, options) => async (_dispatch, _state, extra) => {
    const response = await extra<FolderApiResponse>(
      `/documents/v1/CustomDataroom/initalizeFolder/${entitledUserId}/${id}`,
      {
        ...options,
        method: "post",
        body: { resources: body },
      }
    );

    if (response.status === 204) {
      // return { total: 0, results: [] };
    }

    return response.data.resources;
  };
